// Libraries
import { Component } from "react";

// Components


// Assets
import "./../assets/styles/Contact.css";
import officeGuy from "./../assets/images/workingOffice.png";


class Contact extends Component {
    render() {
        return(
            <div id="contact">
                <div className="container fadeIn">
                    <div className="section s1 slideIn">
                        <h1 className="slideIn">Let's Chat...</h1>
                        <p>
                            If you would like to get a hold of me you can contact me by email. 
                            If you'd like to have a chat about anything I'm more than happy to make time to meet you.
                        </p>
                        <p>You can email me at: v.yen.sftdev@gmail.com</p>
                    </div>
                    <div className="section s2">
                        <img src={officeGuy} alt="" id="officeGuy" />
                    </div>
                </div>
            </div>
        );
    };
};

export default Contact;